module.exports = __webpack_public_path__ + "static/media/Alias Subd Retopology.354823fd.png";